/* eslint-disable no-console */
// eslint-disable-next-line no-unused-vars
import RecordRTC, {RecordRTCPromisesHandler} from 'recordrtc';
import Event from '../Event';
import throttle from 'lodash.throttle';

class MediaRecord extends Event {
    constructor (params) {
        super();
        this.errorList = {
            recordError: '您的浏览器不支持屏幕录制功能，请下载最新版chrome浏览器',
            mediaError: '您的浏览器不支持开启摄像功能，请下载最新版chrome浏览器',
            audioError: '',
            redioError: ''
        };
        this.userMediaStream = null;
        this.videoStream = null;
        this.audioStream = null;
        this.screenStream = null;
        this.recorder = null;
        this.default = {
            video: true,
            audio: true,
            screen: true
        };
        this.params = Object.assign({}, this.default, params);
    }
    init () {
        const {video, audio, screen} = this.params;
        return Promise.all([
            this.initAudio(),
            video && this.initVideo(),
            screen && this.initScreen()
        ]);
    }

    setAudioTrackStatus (enabled) {
        if (this.audioStream) {
            this.audioStream.getTracks()
                .filter(t => t.kind === 'audio')
                .forEach(track => {
                    track.enabled = enabled
                });
        }
    }

    initRecorder () {
        const _this = this;
        if (this.screenStream) {
            if (this.audioStream) {
                this.audioStream.getTracks()
                    .filter(t => t.kind === 'audio')
                    .forEach(track => {
                        _this.screenStream.addTrack(track);
                    });
            }
            this.recorder = new RecordRTCPromisesHandler(this.screenStream, {
                type: 'video',
                // mimeType: 'video/webm',
                disableLogs: true
                // bitsPerSecond: 128000,
                // audioBitsPerSecond: 128000,
                // videoBitsPerSecond: 128000,
                // sampleRate: 96000,
                // frameRate: 30,
                // bitrate: 128000,
            });
        }
    }
    startRecord () {
        if (this.recorder) {
            return this.recorder.startRecording();
        }
        return Promise.reject(new Error('Recorder is not initialized'));
    }
    // eslint-disable-next-line class-methods-use-this
    pauseRecord () {
        if (this.recorder) {
            return this.recorder.pauseRecording();
        }
        return Promise.resolve();
    }

    resumeRecord () {
        if (this.recorder) {
            return this.recorder.resumeRecording();
        }
        return Promise.resolve();
    }
    stopRecord () {
        console.log(this.recorder, '------stopRecord start----');
        if (this.recorder) {
            return this.recorder.stopRecording().then(() => {
                console.log(this.recorder, '------stopRecord success----');
                this.stopStream();
                this.stopAudioProcess();
            });
        }
        this.stopAudioProcess();
        this.stopStream();
        return Promise.resolve();
    }
    stopStream (type) {
        let streamList = [this.screenStream, this.videoStream, this.audioStream];
        if (type === 'video') streamList = [this.videoStream];
        if (type === 'audio') streamList = [this.audioStream];
        streamList.forEach(stream => {
            if (stream) {
                stream.getTracks().forEach(track => {
                    track.stop();
                });
            }
        });
        this.resetStream(type);
    }
    
    resetStream (type) {
        if (type === 'video') this.videoStream = null;
        if (type === 'audio') this.audioStream = null;
        if (!type) {
            this.videoStream = null;
            this.audioStream = null;
            this.screenStream = null;
        }
    }
    getBlob () {
        if (this.recorder) {
            return this.recorder.getBlob();
        }
        return null;
    }
    
    detectRecord () {
        if (!navigator.getDisplayMedia && (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia)) {
            console.error(this.errorList.recordError);
            // throw new Error(this.errorList.recordError);
            return false;
        }
        return true;
    }
    detectMedia () {
        if (!navigator.getUserMedia && (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) {
            console.error(this.errorList.mediaError);
            // throw new Error(this.errorList.mediaError);
            return false;
        }
        return true;
    }
    getScreenMedia (params) {
        if (!this.detectRecord()) return false;
        if (navigator.mediaDevices.getDisplayMedia) {
            return navigator.mediaDevices.getDisplayMedia(params);
        } else if (navigator.getDisplayMedia) {
            return navigator.getDisplayMedia(params);
        }
    }
    getUserMedia (params) {
        if (!this.detectMedia()) return false;
        if (navigator.mediaDevices.getUserMedia) {
            return navigator.mediaDevices.getUserMedia(params);
        } else if (navigator.getUserMedia) {
            return navigator.getUserMedia(params);
        }
    }
    initScreen () {
        return this.getScreenMedia({video: true, audio: true}).then(stream => {
            // 屏幕录制流获取
            this.screenStream = stream;
            // somebody clicked on "Stop sharing"
            stream.getVideoTracks()[0].onended = () => {
                this.emit('userstopedrecord');
            };
            // this.screenStream.width = window.screen.width;
            // this.screenStream.height = window.screen.height;
            // this.screenStream.fullcanvas = true;
        });
    }
    initVideo () {
        return this.getUserMedia({video: true}).then(stream => {
            this.videoStream = stream;
        })
            .catch(error => {
                console.error(error);
            });
    }
    initAudio () {
        return this.getUserMedia({audio: true}).then(stream => {
            this.audioStream = stream;
        })
            .catch(error => {
                console.error(error);
            });
    }
    audioProcess () {
        const _this = this;
        if (this.audioStream) {
            // 将麦克风的声音输入这个对象
            const audioContext = new(window.AudioContext || window.webkitAudioContext)();
            const mediaStreamSource = audioContext.createMediaStreamSource(this.audioStream);
            // 创建一个音频分析对象，采样的缓冲区大小为4096，输入和输出都是单声道
            const scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);
            // 将该分析对象与麦克风音频进行连接
            mediaStreamSource.connect(scriptProcessor);
            // 此举无甚效果，仅仅是因为解决 Chrome 自身的 bug
            scriptProcessor.connect(audioContext.destination);
            // 开始处理音频
            const audioProcess = throttle(e => {
                // 获得缓冲区的输入音频，转换为包含了PCM通道数据的32位浮点数组
                const buffer = e.inputBuffer.getChannelData(0);
                // 获取缓冲区中最大的音量值
                const maxVal = Math.max.apply(Math, buffer);
                // 显示音量值
                _this.emit('audioprocess', maxVal);
            }, 400);
            scriptProcessor.onaudioprocess = audioProcess;
            this.audioContext = audioContext;
            this.mediaStreamSource = mediaStreamSource;
            this.scriptProcessor = scriptProcessor;
        }
    }
    stopAudioProcess () {
        if (this.scriptProcessor) {
            this.scriptProcessor.disconnect(this.audioContext.destination);
            this.scriptProcessor = null;
        }
    }
    distory () {
        this.stopRecord().then(() => {
            this.recorder = null;
            this.videoStream = null;
            this.audioStream = null;
            this.screenStream = null;
            this.scriptProcessor = null;
            this.audioContext = null;
        });
        // this.scriptProcessor.disconnect(this.audioContext.destination);
    }
}
export default MediaRecord;
